import { subHours, parseISO, isWithinInterval } from "date-fns";
import { cn } from "@/lib/utils";

export default function OnlineIndicator({
  lastActiveAt,
  className,
}: {
  lastActiveAt: string | null;
  className?: string;
}) {
  if (!lastActiveAt) {
    return null;
  }

  const isRecentlyActive = () => {
    const lastActive = parseISO(lastActiveAt); // This is already in UTC
    const nowUTC = new Date();
    const oneHourAgoUTC = subHours(nowUTC, 1);
    return isWithinInterval(lastActive, {
      start: oneHourAgoUTC,
      end: nowUTC,
    });
  };

  if (!isRecentlyActive()) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex-shrink-0 w-2 h-2 md:w-3 md:h-3 bg-[#00B430] rounded-full",
        className
      )}
    />
  );
}
